import React, { Component } from 'react';

import SelectOption from './SelectOption/SelectOption';

import classes from './SelectMenu.scss';


class SelectMenu extends Component {

    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.node.contains(e.target)) {
            return;
        }
        if (this.props.closeSelect) {
            this.props.closeSelect();
        }
    }

    render() {
        const border = '1px solid var(--color-border)';
        
        return (
            <div className={`u-width100Percent u-relative`} ref={node => this.node = node}>
                <div 
                    className={classes.Field}
                    style={{ borderBottom: !this.props.isHonorificValid ? '2px solid #ff7d7d': `${border}` }}
                    onClick={this.props.toggleClicked}>{this.props.type === 'pax' || 'age' ? null : '+'} {this.props.value} {this.props.type === 'age' ? 'year' : null}</div>
                    {
                        this.props.active ? 
                        <ul className={`${classes.Select} u-boxShadowThin u-backgroundColorWhite u-borderRadius4 u-absolute u-overflowScroll`} style={{
                            height: this.props.type === 'age' ? '16rem' : 'auto'
                        }}>
                            {
                                this.props.mapping.map((data) => {
                                    if (this.props.type === 'pax') {
                                        return <SelectOption key={data.slNo} onClick={() => this.props.clicked(data.honorificValue)}>{data.honorificName} {data.honorificValue === 'Master' || data.honorificValue === 'Miss' ? <span className={`u-textColorLight u-fontSize13 u-fontWeightRegular`}>Child/Infant</span> : null}</SelectOption>
                                    } else {
                                        return <SelectOption key={data.slNo} onClick={() => this.props.clicked(this.props.type === 'age' ? data.slNo : data.countryCode)}> {this.props.type === 'age' ? data.ageName : data.countryName +  '-' +  data.countryCode}</SelectOption>
                                    }
                                })
                            }
                        </ul> : null
                    }
            </div>
        );
    }
}

export default SelectMenu;


// WEBPACK FOOTER //
// ./src/components/UI/SelectMenu/SelectMenu.js